import { Box, Typography } from "@mui/material";
import { ReviewCardStyled } from "./review-card.styles";
import { ReviewCardProps } from "./types";
import { Edit } from "@mui/icons-material";

const ReviewCard: React.FC<ReviewCardProps> = ({ data, onEditClick }) => {
  return (
    <ReviewCardStyled>
      <Box className="review-content">
        <Box className="title-and-sub-title">
          <Typography className="title">{data.name}</Typography>
          <Typography className="sub-title">{data.content}</Typography>
        </Box>
        <Box>
          <div className="edit-icon-wrapper" onClick={onEditClick}>
            <Edit />
          </div>
          <Typography onClick={onEditClick} className="edit-button">
            Edit
          </Typography>
        </Box>
      </Box>
    </ReviewCardStyled>
  );
};

export default ReviewCard;
